import React, { useEffect } from 'react'
import * as queryString from 'query-string'
import { useLocation } from 'react-router'

import App from '../../component/layouts/App'
import { getInfoPartner } from '../../api/common-api'
import ProvideAuth from '../../component/layouts/ProvideAuth'

const AppContainer = () => {
    const { search } = useLocation()
    useEffect(() => {
        let query = queryString.parse(search)
        const checkUserSession = async () => {
            try {
                const data = {
                    user_session: query?.user_session,
                }
                const infoPartner = await getInfoPartner(data)
                if (infoPartner?.status === 'success') {
                    localStorage.setItem('webviewSessionInfo', JSON.stringify(infoPartner.data))
                } else {
                    localStorage.removeItem('webviewSessionInfo')
                }
            } catch (e) {
                localStorage.removeItem('webviewSessionInfo')
                throw e
            }
        }
        if (query?.user_session) {
            checkUserSession()
        }
    }, [])
    return (
        <ProvideAuth>
            {' '}
            <App />
        </ProvideAuth>
    )
}

export default AppContainer
